// extracted by mini-css-extract-plugin
var _1 = "TMYIR";
var _2 = "sTfjT";
var _3 = "uQESq";
var _4 = "cpOPH";
var _5 = "FUJtc elide";
export { _1 as "backdrop", _2 as "background", _3 as "base", _4 as "label", _5 as "name" }
